import { IHomeHeaderMenu } from "../interfaces/home-header-menu.interface"

export class HomeHeaderMenuConstants {

  static readonly Menu: IHomeHeaderMenu[] = [
    {
      labelKey: "homeHeader.label.dashboard",
      icon:"dashboard",
      routeUrl: "/dashboard",
      megaMenu: {
        image: "access-management",
        items: [
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
            
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
            
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
             
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
            ]
          }
        ]
      }
    },
    {
      labelKey: "homeHeader.label.administration",
      icon:"administration",
      routeUrl: "/administration",
      megaMenu: {
        image: "access-management",
        items: [
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },

            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
   
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
     
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
    
            ]
          }
        ]
      }
    },
    {
      labelKey: "homeHeader.timeAndAttendance.label.timeAndAttendance",
      icon:"time-and-attendance",
      routeUrl: "/time-and-attendance",
      megaMenu: {
        image: "access-management",
        items: [
          {
            headingLabelKey: "homeHeader.timeAndAttendance.label.shift",
            subMenus: [
              {
                labelKey: "homeHeader.timeAndAttendance.label.shiftCategory",
                routeUrl: "/shift-category"
              },
              {
                labelKey: "homeHeader.timeAndAttendance.label.shiftDetails",
                routeUrl: "/shift-details"
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          }
        ]
      }
    },
    {
      labelKey: "homeHeader.label.timeOffManagement",
      icon:"time-off-management",
      routeUrl: "/time-off-management",
      megaMenu: {
        image: "access-management",
        items: [
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          },
          {
            headingLabelKey: "homeHeader.label.heading",
            subMenus: [
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              },
              {
                labelKey: "homeHeader.label.subMenu",
                routeUrl: ""
              }
            ]
          }
        ]
      }
    }
  ]
}